import api from "../services/baseapi";
import axios, { AxiosRequestConfig } from "axios";
import { IApiError } from "../interfaces/IApiError";
import { ApiResponse } from "../types/ApiResponse";
import { AxiosResponse } from "axios";

export const get = async <T>(
  url: string,
  config: AxiosRequestConfig = {},
): Promise<ApiResponse<T>> => {
  try {
    // const response: any = await api.get<T>(
    //   `https://aitools.kapinsights.com/${url}`,
    //   config
    // );
    const response = await api.get<T>(
      `${process.env.REACT_APP_TYPE_API_URL}/${url}`,
      config,
    );

    return { type: "success", data: response.data as any };
  } catch (error: any) {
    const apiError: IApiError = {
      message: error.message,
      code: error.code,
      response: error.response,
    };
    return { type: "error", data: apiError };
  }
};

export const getBlob = async <T>(
  url: string,
  config: AxiosRequestConfig = {},
): Promise<
  | { type: "success"; data: T; headers?: any }
  | { type: "error"; error: IApiError }
> => {
  try {
    const response = await axios.get<T>(
      `${process.env.REACT_APP_TYPE_API_URL}/${url}`,
      config,
    );
    return { type: "success", data: response.data, headers: response.headers };
  } catch (error: any) {
    const apiError: IApiError = {
      message: error.message,
      code: error.code,
      response: error.response,
    };
    return { type: "error", error: apiError };
  }
};

export const post = async <T>(
  url: string,
  data: Record<string, any> | string = {},
  config: AxiosRequestConfig<string> = {},
): Promise<ApiResponse<T>> => {
  try {
    const response = await api.post<T>(
      `${process.env.REACT_APP_TYPE_API_URL}/${url}`,
      data,
      config,
    );

    return { type: "success", data: response.data as any };
  } catch (error: any) {
    const apiError: IApiError = {
      message: error.message,
      code: error.code,
      response: error.response,
    };
    return { type: "error", data: apiError };
  }
};

// export const postWithHeaders = async (
//   url: string,
//   data: Record<string, any> = {},
//   config: AxiosRequestConfig<string> = {}
// ): Promise<ApiResponse<{ data: Blob; headers: any }>> => {
//   try {
//     const response: AxiosResponse<Blob> = await api.post<Blob>(
//       `https://aitools.kapinsights.com/${url}`,
//       data,
//       { ...config, responseType: "blob" }
//     );
//     return {
//       type: "success",
//       data: { data: response.data, headers: response.headers },
//     };
//   } catch (error: any) {
//     const apiError: IApiError = {
//       message: error.message,
//       code: error.code,
//       response: error.response,
//     };
//     return { type: "error", data: apiError };
//   }
// };
export const postWithHeaders = async (
  url: string,
  data: Record<string, any> = {},
  config: AxiosRequestConfig<string> = {},
): Promise<
  | { type: "success"; data: Blob; headers: any }
  | { type: "error"; data: IApiError }
> => {
  try {
    // const response: AxiosResponse<Blob> = await api.post<Blob>(
    //   `https://aitools.kapinsights.com/${url}`,
    //   data,
    //   { ...config, responseType: "blob" }
    // );
    const response: AxiosResponse<Blob> = await api.post<Blob>(
      `${process.env.REACT_APP_TYPE_API_URL}/${url}`,
      data,
      { ...config, responseType: "blob" },
    );
    return {
      type: "success",
      data: response.data, // Keep the raw data
      headers: response.headers, // Expose headers at the top level
    };
  } catch (error: any) {
    const apiError: IApiError = {
      message: error.message,
      code: error.code,
      response: error.response,
    };
    return { type: "error", data: apiError };
  }
};

export const put = async <T>(
  url: string,
  data: Record<string, any> = {},
  config: AxiosRequestConfig = {},
): Promise<ApiResponse<T>> => {
  try {
    // const response: any = await api.put<T>(
    //   `https://aitools.kapinsights.com/${url}`,
    //   data,
    //   config
    // );
    const response = await api.put<T>(
      `${process.env.REACT_APP_TYPE_API_URL}/${url}`,
      data,
      config,
    );

    return { type: "success", data: response.data as any };
  } catch (error: any) {
    const apiError: IApiError = {
      message: error.message,
      code: error.code,
      response: error.response,
    };
    return { type: "error", data: apiError };
  }
};

export const remove = async <T>(
  url: string,
  config: AxiosRequestConfig = {},
): Promise<ApiResponse<T>> => {
  try {
    const response = await api.delete<T>(
      `${process.env.REACT_APP_TYPE_API_URL}/${url}`,
      config,
    );

    return { type: "success", data: response.data };
  } catch (error: any) {
    const apiError: IApiError = {
      message: error.message,
      code: error.code,
      response: error.response,
    };
    return { type: "error", data: apiError };
  }
};

export async function getFileUrlByFileKey(
  fileKey: string,
  platformId: string,
): Promise<string | null> {
  try {
    const base = process.env.REACT_APP_FILE_MANAGER_URL!;
    const url = `${base}/FileData/getFileByFileKey?platformId=${encodeURIComponent(
      platformId,
    )}&fileKey=${encodeURIComponent(fileKey)}`;

    const res: AxiosResponse<any> = await axios.get(url, {
      headers: { Accept: "*/*" },
    });
    const fileUrl = res?.data?.data; // Swagger: { data: "<external-url>" }
    return typeof fileUrl === "string" ? fileUrl : null; // ✅ RETURN
  } catch (e) {
    console.error("getFileUrlByFileKey failed", e);
    return null; // ✅ RETURN
  }
}

// ⬇️ SHTO këtë
export async function fetchExternalFile(
  fileUrl: string,
): Promise<{ blob: Blob; filename?: string; mime?: string }> {
  const res = await fetch(fileUrl, { method: "GET", credentials: "omit" });
  if (!res.ok) throw new Error(`Failed to fetch external file: ${res.status}`);

  const cd = res.headers.get("Content-Disposition") || "";
  const mime = res.headers.get("Content-Type") || "";
  const m = /filename\*?=(?:UTF-8'')?("?)([^";]+)\1/i.exec(cd);
  const filename = m
    ? decodeURIComponent(m[2])
    : decodeURIComponent(new URL(fileUrl).pathname.split("/").pop() || "");

  const blob = await res.blob();
  return { blob, filename, mime: mime || blob.type };
}

// utils/files.ts
// export async function fetchFileByKey(
//   fileKey: string
// ): Promise<{ blob: Blob; filename?: string; mime?: string }> {
//   const url = `${
//     process.env.REACT_APP_TYPE_API_URL
//   }/get_document_by_file_key?file_key=${encodeURIComponent(fileKey)}`;
//   const res = await fetch(url, { headers: { Accept: "*/*" } });
//   if (!res.ok) throw new Error("Failed to download file");
//   const cd = res.headers.get("Content-Disposition") || "";
//   const mt = res.headers.get("Content-Type") || "";
//   const m = /filename\*?=(?:UTF-8'')?("?)([^";]+)\1/i.exec(cd);
//   const filename = m ? decodeURIComponent(m[2]) : undefined;
//   const blob = await res.blob();
//   return { blob, filename, mime: mt || blob.type };
// }

export function guessExt({
  filename,
  mime,
}: {
  filename?: string;
  mime?: string;
}): string {
  const n = (filename || "").toLowerCase();
  if (n.endsWith(".pdf")) return "pdf";
  if (n.endsWith(".docx")) return "docx";
  if (n.endsWith(".doc")) return "doc";
  if (n.endsWith(".xlsx")) return "xlsx";
  if (n.endsWith(".xls")) return "xls";
  if (n.endsWith(".rtf")) return "rtf";
  if (n.endsWith(".txt")) return "txt";
  const m = (mime || "").toLowerCase();
  if (m.includes("pdf")) return "pdf";
  if (m.includes("wordprocessingml")) return "docx";
  if (m.includes("msword")) return "doc";
  if (m.includes("spreadsheetml")) return "xlsx";
  if (m.includes("excel")) return "xls";
  if (m.includes("rtf")) return "rtf";
  if (m.startsWith("text/")) return "txt";
  return "bin";
}

export const patch = async <T>(
  url: string,
  data: Record<string, any> = {},
  config: AxiosRequestConfig = {},
): Promise<ApiResponse<T>> => {
  try {
    const response = await api.patch<T>(
      `${process.env.REACT_APP_TYPE_API_URL}/${url}`,
      data,
      config,
    );

    return { type: "success", data: response.data as any };
  } catch (error: any) {
    const apiError: IApiError = {
      message: error.message,
      code: error.code,
      response: error.response,
    };
    return { type: "error", data: apiError };
  }
};
